import { z } from 'zod';

export const RubricItem = z
  .object({
    weight: z.number(),
    description: z.string(),
  })
  .describe('RubricItem');

export type RubricItem = z.infer<typeof RubricItem>;

export const Rubric = z.array(RubricItem).describe('Rubric');

export type Rubric = z.infer<typeof Rubric>;

// Base rubric schema that can be extended
export const BaseRubricSchema = z
  .object({
    rubric: Rubric,
  })
  .describe('BaseRubricSchema');

export type BaseRubricType = z.infer<typeof BaseRubricSchema>;
